import React from "react";
import { Helmet } from "react-helmet";

const Privacypolicy = () => {
  return (
    <>
    <Helmet>
        <title>
            Privacy Policy - eYantra
        </title>
    </Helmet>
      <div class="container my-5">
        <h1 class="texteYantra text-center">Privacy Policy</h1>
        <p class="text-center">
          This Privacy Policy governs the manner in which eYantra collects,
          maintains, uses, and discloses information collected from users of the
          www.eyantra.com website. This policy applies to the website and all
          the services and products offered by eYantra.
        </p>

        <h2>Personal Identification Information</h2>
        <p>
          We may collect personal identification information from users in
          several ways, such as during site visits, registration on the website,
          newsletter subscriptions, and in connection with services, activities,
          and features available on our site. Users may be asked for their name,
          phone number, email address, mailing address, credit/debit card
          information. Any information provided in connection with eYantra
          products and services is received and stored by us.
        </p>

        <p>
          Users may, however, visit our site anonymously. Personal
          identification information will only be collected with the user’s
          consent when they voluntarily submit it to us. Users can opt not to
          provide certain information, though some services may be unavailable
          without it.
        </p>

        <h2>Non-Personal Identification Information</h2>
        <p>
          We may collect and store non-personal identification information
          whenever users interact with our site. This can include the operating
          system, type of computer, the internet service provider used, and
          other similar information.
        </p>

        <h2>How We Use Collected Information</h2>
        <p>
          eYantra collects and uses user’s personal information for the
          following purposes:
        </p>
        <ul>
          <li>
            <strong>To Improve Customer Service:</strong> The information helps
            us respond to your support requests and needs more efficiently.
          </li>
          <li>
            <strong>To Personalize User Experience:</strong> The information
            allows us to better understand user behavior and improve our
            services and products.
          </li>
          <li>
            <strong>To Improve Our Website:</strong> User feedback and
            information assist in enhancing our website offerings.
          </li>
          <li>
            <strong>To Process Transactions:</strong> Information provided
            during orders will be used solely for processing those transactions
            and providing related services.
          </li>
          <li>
            <strong>To Send Periodic Emails:</strong> The email address provided
            will be used to send order updates, respond to inquiries, or other
            requests. There is an unsubscribe option in every email.
          </li>
        </ul>

        <h2>How We Protect Your Information</h2>
        <p>
          We view the security of your personal information as a vital
          principle. All information, including financial data, is stored and
          processed on computers protected by advanced security protocols that
          comply with the IT Act 2000. Sensitive data exchanges are encrypted
          and transmitted over secure channels.
        </p>

        <h2>Sharing Your Personal Information</h2>
        <p>
          We do not rent, sell, or trade user’s personal information. We may
          share generic demographic information with trusted affiliates and
          business partners for purposes outlined above. Personal information
          may also be shared with our corporate identities for marketing, such
          as sending newsletters.
        </p>

        <h2>Changes to This Privacy Policy</h2>
        <p>
          eYantra may update this privacy policy at any time. We encourage users
          to regularly check this page to stay informed about how we protect
          your information. You are responsible for reviewing this privacy
          policy periodically.
        </p>

        <h2>Your Acceptance of These Terms</h2>
        <p>
          By using this website, you agree to the terms of this privacy policy.
          If you do not agree, please refrain from using our platform.
        </p>

        <h2>Contacting Us</h2>
        <p>
          If you have any questions about this privacy policy or your dealings
          with this site, please contact us at{" "}
          <a className="texteYantra text-decoration-none" href="mailto:info@eyantra.com">info@eyantra.com</a>.
        </p>
      </div>
    </>
  );
};

export default Privacypolicy;
